export default __webpack_public_path__ + "assets/images/favicon/apple-touch-icon.png";